/**
 * Created by PuTi(编程即菩提) 2/19/17.
 * NB root module
 */
var view = require('./core/view');
var model = require('./core/model');
var util = require('./core/util');
var opts = require('./config');
var $ = opts.$;
var seq = 1;
var nb = {
    opts: opts
};

if (!opts.$) {
    $ = opts.$ = require('jquery');
}
if (!opts.window) {
    opts.window = window;
}
if (!opts.document) {
    opts.document = document;
}

function extend(inSuper, inDef) {
    var superPrototype = inSuper.prototype;
    var prototype = Object.create(superPrototype);

    var Type = function () {
        var init = this.init;
        if (init) {
            init.apply(this, arguments);
        }
    };

    $.each(inDef, function (inName, inProp) {
        if (inName == 'method') {
            extendMethods(prototype, inProp);
        } else {
            prototype[inName] = inProp;
        }
    });

    Type.prototype = prototype;
    return Type;
}

function extendMethods(inPrototype, inMethods) {
    var methods = inMethods || {};
    $.each(methods, function (inName, inMethod) {
        var prop = inPrototype[inName];
        if (prop != undefined && typeof prop == "function") {
            if (inName === 'init') {
                inPrototype[inName] = (function (superFn, fn) {
                    return function () {
                        superFn.apply(this, arguments);
                        return fn.apply(this, arguments);
                    };
                })(prop, inMethod);
            } else {
                //overwrite or override
                inPrototype[inName] = (function (superFn, fn) {
                    return function () {
                        var temp, result;
                        temp = this.parent;
                        this.parent = superFn;
                        result = fn.apply(this, arguments);
                        this.parent = temp;
                        return result;
                    };
                })(prop, inMethod);
            }
        } else {
            inPrototype[inName] = inMethod;
        }
    });
}

function name(inName, inTarget, inGlobal) {
    var handler = inGlobal || window;
    var last;
    if (inName) {
        var names = inName.split('.');
        last = names.pop();
        $.each(names, function (inIndex, inName) {
            var temp = handler[inName];
            if (temp) {
                handler = temp;
                return;
            }
            handler = handler[inName] = {};
        });
    }
    if (last) {
        handler[last] = inTarget;
    }
    return inTarget;
}

function NBType() {
}

var RootType = extend(NBType, {});
nb.define = function (inDef) {
    var parent = inDef.parent;
    var view = inDef.view;
    if (view) {
        parent = parent || nb.View;
    }
    return extend(parent || RootType, inDef);
};
nb.NBType = NBType;
nb.extend = extend;
nb.name = name;
nb.getSeq = function () {
    return seq++;
};
view(nb);
model(nb);
util(nb);
module.exports = nb;



//////////////////
// WEBPACK FOOTER
// /Users/Shared/Previously Relocated Items/Security/workspace/nb2-webpack3/server/nb/core/js/nb.js
// module id = 33
// module chunks = 42